const exportFileName = 'all_contact_info';

// headers.js
const auctionContactHeader = [
  'Auction Name',
  'Contact Name',
  'Title',
  'Email',
  'Phone',
  'Contact Type',
  'Guarantee Confirm',
  'Guarantee Cancel',
  'Returns',
  'Veh Not Covered',
];

// Replace null values with empty strings
const replaceNullData = data => data.map(obj => Object.fromEntries(
  Object.entries(obj).map(([key, value]) => [
    key,
    value !== null && value !== undefined ? value : '',
  ])
));

// Transform data for CSV export
const auctionContactCSV = data => {
  return replaceNullData(data).map(item => ({
    'Auction Name': item.auctionName,
    'Contact Name': item.contactName,
    Title: item.title,
    Email: item.contactEmail,
    Phone: item.phone,
    'Contact Type': item.contactType,
    'Guarantee Confirm': String(item.guaranteeConfirm).toUpperCase(),
    'Guarantee Cancel': String(item.guaranteeCancel).toUpperCase(),
    Returns: String(item.returns).toUpperCase(),
    'Veh Not Covered': String(item.vehNotCovered).toUpperCase(),
  }));
};

export { auctionContactHeader, auctionContactCSV, exportFileName };
